
import { padNum } from '/services/helpers'

export default

	props:
		slide: Object
		index: Number|String
		count: Number|String
		paginationStyle:
			type: String
			validator: (val) -> val in ['dots', 'arrows']
			default: 'dots'

	computed:
		imageAsset: -> if @slide.landscapeImage?.length then @slide.landscapeImage else @slide.portraitImage

		hasVideo: -> @slide.landscapeVideo?.length || @slide.portraitVideo?.length

		sizes: -> "(min-width: 1440px) 1440px, ( (max-width: 1439px) and (min-width: 768px) 100vw ), 100vw"

		isDotPagination: -> @paginationStyle == 'dots'

		# Removing color from button so it respects our computed button color
		computedButtons: -> @slide.button.map (button) -> {...button, color: undefined}

		buttonColor: ->
			return 'white' if @slide.theme == 'dark'
			return 'charcoal' if @slide.theme == 'light'

		countArray: -> [...Array(@count).keys()]

	methods:
		padNum: padNum

